import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SearchIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'small' : _b;
    var iconSize = {
        large: 'h-auto w-8',
        medium: 'h-auto w-6',
        small: 'h-auto w-4',
    };
    return (_jsxs("svg", { xmlns: 'http://www.w3.org/2000/svg', className: iconSize[size], viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round', children: [_jsx("circle", { cx: '11', cy: '11', r: '8' }), _jsx("line", { x1: '21', y1: '21', x2: '16.65', y2: '16.65' })] }));
};
